import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../styles/Header.scss";
import { Logo } from "./Logo";
import LanguageSwitcherCircular from "./LanguageSwitcherCircular";
import { useMediaQuery } from "@mui/material";

const Header: React.FC = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  // Get the current language from the URL path
  const currentLanguage =
    location.pathname.split("/")[1] || i18n.language || "en";

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const isMobile = useMediaQuery("(max-width:800px)");

  // Create language-specific base path
  const basePath = `/${currentLanguage}`;

  return (
    <header className="header">
      <Logo />

      <nav className={`nav`}>
        <ul className="nav-list">
          <li>
            <Link onClick={() => scrollToSection("HomeSection")} to={basePath}>
              {t("header_home")}
            </Link>
          </li>{" "}
          <li>
            <Link onClick={() => scrollToSection("AboutSection")} to={basePath}>
              {t("header_about_us")}
            </Link>
          </li>
          <li>
            <Link
              onClick={() => scrollToSection("servicesSection")}
              to={basePath}
            >
              {t("header_services")}
            </Link>
          </li>
          <li>
            <Link
              to={basePath}
              onClick={() => scrollToSection("TestimonialsSection")}
            >
              {t("header_testimonials")}
            </Link>
          </li>
        </ul>
        <div className="vertical-divider"></div>
        <div className="contact-us">
          <Link
            to={basePath}
            onClick={() => scrollToSection("ContactUsSection")}
            className="contact-title"
          >
            {t("header_contact_us")}
          </Link>

          <img src="/images/arrow.svg" alt="down-arrow" />
        </div>
      </nav>
      {!isMobile && <LanguageSwitcherCircular />}
    </header>
  );
};

export default Header;
